import ErrorHandlerComponent from './ErrorHandler'

export default ErrorHandlerComponent